import type { Ni18nOptions } from 'ni18n';

export const ni18nConfig: Ni18nOptions = {
  supportedLngs: ['en', 'fr'],
  ns: ['common', 'modal'],
};
